import { learningItemSlugs } from "utils/constants"

export function getAdjustedScore(score: number, slug: string): number {
  // M.Ed scores are displayed in a 4 point system
  if (slug === learningItemSlugs.med) return (score / 10) * 4

  return score
}

/**
 * Usage: truncate(3.782333333333333, 2) // 3.78
 *
 * Scaled value is snapped to 9 decimal places before flooring, otherwise
 * IEEE-754 artifacts truncate a digit too far: (8.7 / 10) * 4 is
 * 3.4799999999999995, which would floor to 3.47 instead of 3.48.
 */
export function truncateScore(num: number, decimals = 2) {
  const factor = 10 ** decimals
  const scaled = Number((num * factor).toFixed(9))
  return Math.floor(scaled) / factor
}
